import axios from "../axios";
const END_POINT_PLAN = "/plans";
const END_POINT = "/plan-details";

const createPlan = (payload) => axios.post(`${END_POINT_PLAN}`, payload);
const searchPlan = (payload) => axios.post(`${END_POINT}/search`, payload);
const searchPlanWeek = (payload) => axios.post(`${END_POINT}/search-for-week`, payload);
const searchPlanOneDay = (payload) => axios.post(`${END_POINT}/search-for-one-day`, payload);
const searchLastInUsePlan = (id) =>
  axios.get(
    `${END_POINT_PLAN}/find-one-for-in-use/${id}?time=${new Date().getTime()}`
  );
const reservePlan = (payload) =>
  axios.post(
    `${END_POINT}/times/turns/${payload.planDetailId}/${payload.timeId}`,
    {
      turnUserId: payload.turnUserId,
    }
  );
const deleteTurnOfPlan = (payload) =>
  axios.delete(`${END_POINT}/times/turns/${payload.planDetailId}/${payload.timeId}`, {
    data:{turnOfTimePlanDetailId: payload.turnId}
  });
const updateForCome = (payload) =>
  axios.patch(
    `${END_POINT}/times/turns/update-for-come/${payload.planDetailId}/${payload.timeId}`,
    {
      turnOfTimePlanDetailId: payload.turnOfTimePlanDetailId,
      isCome: payload.isCome,
    }
  );
const updateForMove = (payload) =>
  axios.patch(
    `${END_POINT}/times/turns/update-for-move/${payload.displacementPlanDetailsId}/${payload.displacementTimeId}`,
    {
      ids: [
        {
          planDetailId: payload.movePlanDetailsId,
          timeId: payload.moveTimeId,
          turnOfTimePlanDetailId: payload.moveTurnId,
        },
      ],
    }
  );
const findInUsePlan = (payload) =>
  axios.get(
    `${END_POINT_PLAN}/find-one-for-in-use/${payload}?time=${new Date().getTime()}`
  );
const searchForTurn = (payload) =>
  axios.post(`${END_POINT}/search-for-turn`, payload);

  const getTurnInfo = (payload) =>
  axios.get(
    `${END_POINT}/times/turns/${payload.planDetailId}/${payload.timeId}/${payload.turnOfTimePlanDetailId}`
  );

  const turnHistory = (payload) =>
  axios.get(
    `${END_POINT}/turn-history/${payload.planDetailId}/${payload.timeId}/${payload.turnOfTimePlanDetailId}`
  );

  const ReferenceHistory = (payload) =>
  axios.post(
    `${END_POINT}/history-for-user-turn`,payload
  );


export {
  createPlan,
  searchPlan,
  searchPlanWeek,
  searchPlanOneDay,
  deleteTurnOfPlan,
  getTurnInfo,
  reservePlan,
  updateForCome,
  updateForMove,
  findInUsePlan,
  searchForTurn,
  searchLastInUsePlan,
  turnHistory,
  ReferenceHistory
};
